export default {
    CustomerList: {
        ChooseCustomer: 'Choose customer',
    },

    Customer: {
        SafesOnline: 'Safes online',
        CurrentBalance: 'Current Balance',
        DailySales: 'Daily Sales',
        ActiveWarnings: 'Active Warnings',
        Of: 'OF',
        In: 'IN',
        Branches: 'BRANCHES'
    },

    Branch: {
        ExportTransactions: "Export Transactions",
        ManageOperators: "Manage Operators",
        ShowOnMap: "Show on map",
        CurrentBalance: "Current Balance",
        DailySales: 'Daily Sales',
        MainCurrency: 'Main Currency',
        TransactionDays: 'Transactiondays'
    },

    BranchList: {
        Name: 'Name',
        Status: 'Status',
        BalanceAmount: 'Balance',
        BalanceCurrency: 'Balance currency',
        LastBalance: 'Updated',
        Branches: 'Branches',
    },

    BranchListFilter: {
        Branches: 'Branches',
        SearchCriteria: 'Find branch...',
    },


    Chart: {
        Sales: 'Sales',
        Pickup: 'Pickup',
        Balance: 'Balance',
        Difference: 'Difference',
        Confirmed: 'Confirmed',
        SalesBalancesAndPickups: 'Sales, Balances & Pickups',
        NoDataAvailable: 'No Data available',
        SafebagBalance: 'Safebag balance',
        RecyclableBalance: 'Recyclable balance',
        ManualDepositBalance: 'Manual deposit balance',
        OverflowBalance: 'Overflow balance'
    },

    ChartDenominations: {
        Deposited: 'Deposited',
        Recyclable: 'Recyclable',
        Denominations: 'Denominations',
        NoDataAvailable: 'No Data available'
    },

    ChartTransactionDay: {
        ProcessedSales: 'Processed Sales In',
        UnprocessedSales: 'Unprocessed Sales In',
        SalesOut: 'Sales Out',
        SalesPerHour: 'Sales per hour'
    },

    CustomerHeader: {
        ShowOnMap: 'Show on map',
        Branches: 'Branches',
        Branch: 'Branch',
        ExportTransactions: 'Transactions',
    },
    
    DeviceStatus: {
        AllOk: 'All Ok',
    },
    
    DeviceStatusList: {
        Safes: 'Safes',
    },

    ExportForm: {
        ExportTransactions: 'Export Transactions',
        Cancel: 'Cancel',
        Export: 'Export',
        FromDate: 'From Date',
        Time: 'Time',
        EndDate: 'End Date'
    },

    ForgotPasswordForm: {
        ForgotHeader: 'Forgot your password?',
        ForgotText: 'Please enter your email below and click the button. You will receive an email with further instructions.',
        LoginLink: 'Back to login',
        EmailAddress: 'E-mail address',
        Submit: 'Send e-mail',
        ErrorMessage: 'We were unable to send your request to the server'
    },

    LoginPage: {
        LoginHeader: 'Welcome',
        LoginText: 'Log in below using your email and password',
        LoginForgot: 'Forgot your password?',
        Username: 'EMAIL',
        Password: 'PASSWORD',
        Login: 'Login'
    },

    ResetPasswordPage: {
        ResetHeader: 'Reset password',
        ResetText: 'Enter your new password.'
    },

    Drawer: {
        Dashboard: 'Dashboard',
        SwitchCustomer: 'Switch customer',
        MyProfile: 'My Profile',
        Report: 'Report',
        Logout: 'Logout'
    },

    OperatorForm: {
        UserId: 'User Id',
        FirstName: 'First Name',
        LastName: 'Last Name',
        Pin: 'Pin',
        Save: 'Save',
        Delete: 'Delete',
        Operator: 'Operator'
    },

    OperatorList: {
        AddOperator: 'Add Operator',
        Operators: 'Operators',
        Name: 'Name'
    },

    Profile: {
        Profile: 'Profile',
        Name: 'Name',
        Language: 'Language',
        Password: 'Password',
        ConfirmPassword: 'Confirm Password',
        Update: 'Update'
    },

    ResetPasswordForm: {
        NewPassword: 'New Password',
        ConfirmPassword: 'Confirm Password',
        Submit: 'Submit'
    },

    InviteUserForm: {
        InviteHeader: 'User Invited',
        InviteText: 'Please fill in your profile data and press Save to be able to login.',
        Name: 'Name',
        Language: 'Language',
        NewPassword: 'New Password',
        ConfirmPassword: 'Confirm Password',
        Submit: 'Save'
    },

    TransactionList: {
        Type: 'Type',
        Operator: 'Operator',
        When: 'When',
        Amount: 'Amount',
        Currency: 'Currency',
        Transactions: 'Transactions',
        Device: 'Device',
        SalesDay: 'SalesDay',
        HoverDeposit: 'Sales in',
        HoverSalesIn: 'Sales in',
        HoverSalesOut: 'Sales out',
        HoverManualDeposit: 'Manual deposit',
        HoverCollection: 'Collection',
        HoverCollectionNotes: 'Collection of notes',
        HoverCollectionCoins: 'Collection of coins',
        HoverCollectionEnvelope: 'Collection of manual deposits',
        HoverCollectionOK: 'Collection confirmed',
        HoverCollectionNotesOK: 'Collection of notes confirmed',
        HoverCollectionCoinsOK: 'Collection of coins confirmed',
        HoverCollectionEnvelopeOK: 'Collection of manual deposits confirmed',
        HoverCollectionNOK: 'Collection difference',
        HoverCollectionNotesNOK: 'Collection of notes difference',
        HoverCollectionCoinsNOK: 'Collection of coins difference',
        HoverCollectionEnvelopeNOK: 'Collection of manual deposits difference',
        HoverDrain: 'Removal',
        HoverRefill: 'Refill',
        HoverExchange: 'Exchange',
        HoverExchangeIn: 'Exchange in',
        HoverExchangeOut: 'Exchange out',
        HoverCounterfeit: 'Counterfeit',
        HoverInternal: 'Internal transaction',
        HoverNOP: 'No Operation'
    },

    TransactionDayList: {
        Date: "Date",
        Sales: "Sales",
        Pickup: "Pickup",
        Balance: "Balance",
        TransactionDays: "Transactiondays"
    },

    TransactionDay: {
        Date: "Date",
        Sales: "Sales",
        Pickup: "Pickup",
        Balance: "Balance",
        TransactionDays: "Transactiondays",
        ExportTransactions: "Transactions"
    },

    TransactionDatePicker: {
        Date: 'Date'
    },

    ReportForm: {
        Title: "Schedule Report",
        Enabled: 'Enable scheduling report',
        ReportSaved: 'Report saved',
        NextExecution: 'Next report execution: ',
        Reports: 'Reports',
        Report: 'Report',
        ReportTRANSACTION: 'Transaction report',
        ReportBALANCE: 'Balance report',
        ReportOPERATOR: 'Operator report',
        ReportTypeCSV: 'CSV',
        ReportTypeEXCEL: 'Excel',
        ReportTypePDF: 'PDF',
        Execution: 'Execution',
        ExecutionTypeMonth: 'Once per month',
        ExecutionTypeWeekDay: 'On weekdays',
        ExecutionDay: 'Day in month',
        ExecutionTime: 'Execution time',
        ExecutionTimePattern: '00:00',
        ExecutionWeekDayMONDAY: 'Monday',
        ExecutionWeekDayTUESDAY: 'Tuesday',
        ExecutionWeekDayWEDNESDAY: 'Wednesday',
        ExecutionWeekDayTHURSDAY: 'Thursday',
        ExecutionWeekDayFRIDAY: 'Friday',
        ExecutionWeekDaySATURDAY: 'Saturday',
        ExecutionWeekDaySUNDAY: 'Sunday',
        Content: 'Content',
        ContentTypeSinceLast: 'All since last report',
        ContentTypeRelative: 'Relative',
        ContentRelativeType: 'Past: ',
        ContentRelativeTypeDAY: 'Days',
        ContentRelativeTypeWEEK: 'Weeks',
        ContentRelativeTypeMONTH: 'Months',
        ErrorFieldRequired: 'Field required!',
        ErrorSelectAtLeastOneDay: 'Select at least one day.',
        ErrorFormat: 'Should be in format: 00:00',
        ErrorEnableAtLeastOneReport: 'Enable at least one report',
        ErrorEnableAtLeastOneReportItem: 'Enable at least one reportitem when a report is enabled',
        Update: 'Save'
    }
};


// WEBPACK FOOTER //
// ./src/lib/i18n/en.js